import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import ReportingFrequencyList from './ReportingFrequencyList';

const ReportingFrequencies = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Derechos de Agua', icon: 'icon-droplets' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Frecuencias de Reportabilidad' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<ReportingFrequencyList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ReportingFrequencies;
